import {
    AutocompleteInput,
    BulkDeleteButton,
    DateInput,
    ListProps,
    NullableBooleanInput,
    ReferenceInput,
    SelectInput,
    TextInput,
} from "react-admin";
import {CustomList} from "../../components/CustomList";
import {useOptionsResource} from "../../shared/hooks/useOptionsResource";
import {getDefaultListProps, initField} from "../../shared/utils";
import {DeliveryGroupDatagrid} from "./DeliveryGroupDatagrid";

export const DeliveryGroupList = (props: ListProps) => {
  const { data: options } = useOptionsResource("GET");
  const filters = options
    ? [
      <TextInput alwaysOn {...initField("id", options)} />,
      <DateInput {...initField("created_date_after", options)} label="Creata dal" />,
      <DateInput {...initField("created_date_before", options)} label="Crerata al" />,
      <SelectInput
        choices={options.type.choices}
        {...initField("type", options, "array")}
        alwaysOn
      />,
      <ReferenceInput
        {...initField("subject", options)}
        filter={{ departments: "Soggetto" }}
        reference="autocomplete/subject"
        alwaysOn
      >
        <AutocompleteInput optionText="label" />
      </ReferenceInput>,
      <NullableBooleanInput {...initField("has_file", options)} label="Borderaux firmato" />,
    ]
    : [];
  return options ? (
    <CustomList
      sort={{ field: "id", order: "DESC" }}
      filters={filters}
      {...getDefaultListProps(props)}
      bulkActionButtons={
        <>
          <BulkDeleteButton undoable />
        </>
      }
    >
      <DeliveryGroupDatagrid options={options} />
    </CustomList>
  ) : null;
};
